import { Link } from "react-router-dom";
import { useGetbrands } from "../../hooks/useProducts";
import { useState } from "react";
import { useClient } from "../../context/client-context";

const HeaderBrandsMain = ({
  handleMenuClick,
  activeIndex,
  setActiveIndex,
  isForMobile = false,
  isAuthenticated,
  user,
  handleLogOut,
}) => {
  const [pageData, setPageData] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const {
    data = {},
    // isPending,
    isError: brandsIsError,
    error: brandsError,
  } = useGetbrands(pageData);

  let { data: brands = [] } = data?.brands ?? {};
  // let brands = [
  //   {
  //     id: "9d895a0b-23d4-4702-8a21-7a93003e39b7",
  //     name: "Animal Parade",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/9d954fd2-3483-4c1d-a70f-ace9c7257c30/images/9d954fd2-3483-4c1d-a70f-ace9c7257c30_averon_logo_20260925205228.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  //   {
  //     id: "b06f61ee-dfb6-4dbc-b6fe-a4ab7e09925d",
  //     name: "CeraVe",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/7d92190e-f250-484b-8496-1bd2441a6b44/images/7d92190e-f250-484b-8496-1bd2441a6b44_averon_logo_20260925204304.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  //   {
  //     id: "edea4690-217f-4ba5-8a4f-ca63634b90ee",
  //     name: "La Roche-Posay",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/a0ffa8b0-39bb-41d8-b48d-b08c66aa3296/images/a0ffa8b0-39bb-41d8-b48d-b08c66aa3296_averon_logo_20260925204202.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  //   {
  //     id: "3fd15e39-8dec-42fa-95ca-b4795cfef66f",
  //     name: "L'Oréal",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/433f5ab9-05d8-4367-937b-eb6e509aac6f/images/433f5ab9-05d8-4367-937b-eb6e509aac6f_averon_logo_20260925204335.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  //   {
  //     id: "a9e70589-5d7f-443e-bded-003d3551e078",
  //     name: "Mizani",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/a21ae085-fa21-40e9-8573-eed6723573ad/images/a21ae085-fa21-40e9-8573-eed6723573ad_averon_logo_20260925204445.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  //   {
  //     id: "09d950d2-cc4e-48a3-ba5a-84b709e64815",
  //     name: "Nature's Plus",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/47ce0125-ba45-4404-98db-62543c23069f/images/47ce0125-ba45-4404-98db-62543c23069f_averon_logo_20260925205033.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  //   {
  //     id: "dadf7b98-b0df-4525-af8e-73e85f46e6a3",
  //     name: "Now",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/5abe2207-c378-4a8f-920a-e281c362fbfa/images/5abe2207-c378-4a8f-920a-e281c362fbfa_averon_logo_20260925204006.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  //   {
  //     id: "a10c3f37-e6c7-47f7-881d-5364828b5764",
  //     name: "Quest",
  //     brandImageUrl:
  //       "https://phamacoredispatch.co.ke:5007/uploads/brands/5433a368-18aa-45cf-8d82-168c24051f7c/images/5433a368-18aa-45cf-8d82-168c24051f7c_averon_logo_20260925204609.png",
  //     productCount: 0,
  //     isActive: true,
  //   },
  // ];
  const client = useClient();

  let pageSize = data?.brands?.count ?? 0;

  const hasNextPage = () => {
    return pageData.pageIndex + 1 >= pageSize / pageData.pageSize;
  };

  if (brandsIsError)
    return (
      <>
        {isForMobile ? (
          <ul className="nav-menu flex-align nav-menu--mobile">
            <li className="on-hover-item nav-menu__item has-submenu">
              <Link to="#" className="nav-menu__link">
                Error getting brands {brandsError}
              </Link>
            </li>
            <li className="common-dropdown__item nav-submenu__item">
              <Link
                to="/auth/login"
                className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                onClick={() => setActiveIndex(null)}
              >
                {" "}
                My Account
              </Link>
            </li>
            {isAuthenticated ? (
              <>
                <li
                  onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item has-submenu ${
                    activeIndex === 1 ? "d-block" : ""
                  }`}
                >
                  <Link to="#" className="nav-menu__link">
                    <span className="text-2xl text-gray-700 item-hover__text">
                      <i className="ph ph-user-circle" />
                    </span>
                    {user?.userName || "My Account"}
                  </Link>
                  <ul
                    className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                      activeIndex === 1 ? "open" : ""
                    }`}
                  >
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/orders"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                        onClick={() => setActiveIndex(null)}
                      >
                        {" "}
                        My Orders
                      </Link>
                    </li>
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/customer/account"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                        onClick={() => setActiveIndex(null)}
                      >
                        {" "}
                        My Profile
                      </Link>
                    </li>
                    <li
                      className="common-dropdown__item nav-submenu__item"
                      onClick={handleLogOut}
                      role="button"
                    >
                      <span className="common-dropdown__link nav-submenu__link hover-bg-danger-100">
                        Logout
                      </span>
                    </li>
                  </ul>
                </li>
                <li
                  // onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item mt-5`}
                >
                  <Link
                    to="/products/prescription-products"
                    className="btn btn-sm bg-gray-600 py-8"
                  >
                    <i className="ph ph-file-arrow-up me-5"></i>
                    Prescriptions
                  </Link>
                </li>
              </>
            ) : (
              <li className="common-dropdown__item nav-submenu__item">
                <Link
                  to="/auth/login"
                  className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                  onClick={() => setActiveIndex(null)}
                >
                  {" "}
                  My Account
                </Link>
              </li>
            )}
          </ul>
        ) : (
          <ul className="nav-menu flex-align ">
            <li className="on-hover-item nav-menu__item has-submenu">
              <Link to="#" className="nav-menu__link">
                Brands
              </Link>
              <div className="container-fluid on-hover-dropdown common-dropdown nav-submenu scroll-sm">
                Error getting brands {brandsError}
              </div>
            </li>
          </ul>
        )}
      </>
    );

  return (
    <>
      {isForMobile ? (
        <>
          <ul className="nav-menu flex-align nav-menu--mobile">
            {/* Brands */}
            <li
              onClick={() => handleMenuClick(0)}
              className={`on-hover-item nav-menu__item has-submenu ${
                activeIndex === 0 ? "d-block" : ""
              }`}
            >
              <Link to="#" className="nav-menu__link tex-sm">
                Brands
              </Link>
              <ul
                className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                  activeIndex === 0 ? "open" : ""
                }`}
              >
                {brands.map((brand, index) => (
                  <li
                    className="common-dropdown__item nav-submenu__item"
                    key={index}
                  >
                    <Link
                      to={`/products/brands?brand=${brand?.name}&BrandId=${brand.id}`}
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {brand?.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            {isAuthenticated ? (
              <>
                <li
                  onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item has-submenu ${
                    activeIndex === 1 ? "d-block" : ""
                  }`}
                >
                  <Link to="#" className="nav-menu__link">
                    <span className="text-2xl text-gray-700 item-hover__text">
                      <i className="ph ph-user-circle" />
                    </span>
                    {user?.userName || "My Account"}
                  </Link>
                  <ul
                    className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                      activeIndex === 1 ? "open" : ""
                    }`}
                  >
                    {/* <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/orders"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      My Orders
                    </Link>
                  </li> */}
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/profile"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                        onClick={() => setActiveIndex(null)}
                      >
                        {" "}
                        My Profile
                      </Link>
                    </li>
                    <li
                      className="common-dropdown__item nav-submenu__item"
                      onClick={handleLogOut}
                      role="button"
                    >
                      <span className="common-dropdown__link nav-submenu__link hover-bg-danger-100">
                        Logout
                      </span>
                    </li>
                  </ul>
                </li>
                <li
                  // onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item mt-5`}
                >
                  <Link
                    to="/products/prescription-products"
                    className="btn btn-sm bg-gray-600 py-8"
                  >
                    <i className="ph ph-file-arrow-up me-5"></i>
                    Prescriptions
                  </Link>
                </li>
                <a
                  href="tel:+254702585388"
                  className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
                >
                  <div className="d-flex text-32">
                    <i className="ph ph-phone-call" />
                  </div>
                  {client.contact}
                </a>
              </>
            ) : (
              <>
                <li className="common-dropdown__item nav-submenu__item">
                  <Link
                    to="/auth/login"
                    className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                    onClick={() => setActiveIndex(null)}
                  >
                    My Account
                  </Link>
                </li>
              </>
            )}
          </ul>
          <a
            href="tel:+254702585388"
            className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex"
          >
            <div className="d-flex text-32">
              <i className="ph ph-phone-call" />
            </div>
            {client.contact}
          </a>
        </>
      ) : (
        <ul className="nav-menu flex-align ">
          <li className="on-hover-item nav-menu__item has-submenu">
            <Link to="#" className="nav-menu__link text-sm">
              Brands
            </Link>
            <div className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
              <p className="fw-bold fs-6 text-dark">Brands</p>
              <p className="text-xs">
                Explore our {brands?.length || 0} brands of product
              </p>
              <div className="brands-grid mt-3">
                {brands.map((brand) => (
                  <div className="brands-grid__item" key={brand.id}>
                    <Link
                      to={`/products/brands?brand=${encodeURIComponent(
                        brand.name,
                      )}&BrandId=${brand.id}`}
                      className="brands-grid__link"
                    >
                      <div className="brands-grid__logo">
                        <img
                          src={brand?.brandImageUrl}
                          alt={`${brand?.name} logo`}
                        />
                      </div>

                      <p className="brands-grid__name">{brand?.name}</p>
                    </Link>
                  </div>
                ))}
              </div>
              {/* <div className="d-flex flex-wrap gap-5 mt-5 px-10">
                {brands.map((brand, index) => (
                  <div
                    className="col-md-3 common-dropdown__item nav-submenu__item shadow p-10 text-center hover-bg-main-50 hover-text-main-600"
                    key={index}
                  >
                    <Link
                      to={`/products/brands?brand=${brand.name}&BrandId=${brand.id}`}
                    >
                      <img
                        // src={"/assets/images/thumbs/brand-img7.png"}
                        src={brand?.brandImageUrl}
                        className="img-fluid"
                        width={30}
                        alt=""
                      />
                      <p className="text-dark text-xs">{brand?.name}</p>
                    </Link>
                  </div>
                ))}
              </div> */}
              <hr />
              <div className="d-flex justify-content-start">
                <div>
                  <button
                    className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                    disabled={pageData.pageIndex === 0}
                    onClick={() =>
                      setPageData((prevData) => ({
                        ...prevData,
                        pageIndex: prevData.pageIndex - 1,
                      }))
                    }
                  >
                    <i className="ph-bold ph-arrow-left" />
                  </button>
                  {!hasNextPage() && (
                    <button
                      className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                      disabled={hasNextPage()}
                      onClick={() =>
                        setPageData((prevData) => ({
                          ...prevData,
                          pageIndex: prevData.pageIndex + 1,
                        }))
                      }
                    >
                      <i className="ph-bold ph-arrow-right" />
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/* <ul className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
            <li className="common-dropdown__item nav-submenu__item">
              <NavLink
                to="/"
                className={(navData) =>
                  navData.isActive
                    ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                    : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                }
              >
                Home Grocery
              </NavLink>
            </li>
            <li className="common-dropdown__item nav-submenu__item">
              <NavLink
                to="/index-two"
                className={(navData) =>
                  navData.isActive
                    ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                    : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                }
              >
                {" "}
                Home Electronics
              </NavLink>
            </li>
            <li className="common-dropdown__item nav-submenu__item">
              <NavLink
                to="/index-three"
                className={(navData) =>
                  navData.isActive
                    ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                    : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                }
              >
                Home Fashion
              </NavLink>
            </li>
          </ul> */}
          </li>
        </ul>
      )}
    </>
  );
};

export default HeaderBrandsMain;
